import { Link } from "react-router-dom";

import { Icon } from "~/assets/icons/Icon";

import styles from "./NoData.module.scss";

type NoDataProps = {
  title: string;
  description?: string;
  children?: React.ReactNode;
  path?: string;
  buttonLabel?: string;
  disabled?: boolean;
  blockWidth?: string | number;
  onClick?: () => void;
  iconWidth?: string;
  iconHeight?: string;
};

const NoData = ({
  title,
  description,
  children,
  buttonLabel,
  disabled,
  blockWidth,
  path,
  onClick,
  iconWidth = "10.75rem",
  iconHeight = "8.75rem",
}: NoDataProps) => {
  return (
    <div className={styles.emptyDashboard}>
      <div
        className={styles.emptyDashboardBlock}
        style={blockWidth ? { width: blockWidth } : undefined}
      >
        <Icon
          iconName="NoDashboardSites"
          width={iconWidth}
          height={iconHeight}
        />
        <p className={styles.emptyDashboardTitle}>{title}</p>
        <p className={styles.emptyDashboardDescription}>{description}</p>
        {buttonLabel &&
          path &&
          (disabled ? (
            <span
              className={styles.emptyDashboardButtonDisabled}
              aria-disabled="true"
            >
              <Icon iconName="PlusIcon" color="currentColor" /> {buttonLabel}
            </span>
          ) : (
            <Link
              to={path}
              className={styles.emptyDashboardLink}
              onClick={() => onClick?.()}
            >
              <span className={styles.emptyDashboardButton}>
                <Icon iconName="PlusIcon" /> {buttonLabel}
              </span>
            </Link>
          ))}
      </div>
      {children}
    </div>
  );
};
export default NoData;
